module.exports = __webpack_public_path__ + "assets/building-right.ff3d8a64.svg";